/*///////////////////////////////
///jsonデータを振り分ける関数
///data:jsonデータ
///keyData:キー名
///////////////////////////////*/
function newsJson (data) {
  ///一旦リストを初期化
  $(".news_list").empty();
  let dataCount = 0;
  for (let i = 0; i < 3; i++ in data.contents) {
    /////////jsonデータ出力箇所をhtmlテンプレートに登録
    let contents = data.contents[i];
    let contentHtml = '<dt class="news_day"><span class="category cate-'+ contents.page_type +'"></span><span class="update">'+ contents.update +'</span></dt>\
    <dd><a href="/en/news/' + contents.id + '">' + contents.title + '</a></dd>'
  /////////jsonを出力したリストを表示させる
  $(contentHtml).appendTo(".news_list").hide().fadeIn();
  dataCount++;
  }
  if (dataCount <= 0) {
    $("<li class=\"news_list__item\"><p>該当する情報がありません。</p></li>").appendTo(".news_list").hide().fadeIn();
  }
}
 function shopJson (data) {
   ///一旦リストを初期化
   $(".shoplist .row").empty();
   let dataCount = 0;
   for (let s in data.contents) {
     /////////jsonデータ出力箇所をhtmlテンプレートに登録
     let contents = data.contents[s];
     let shoplistHtml = '<li class="col sm-4 xs-12">\
     <div class="shop">\
       <a href="/en/shop/' + contents.id + '">\
       <div class="shop_logo thumbnail_image">\
         <img src="/cms-img/shop/' + contents.thumbnail_image + '" alt="'+ contents.shop_name + '" class="">\
       </div>\
       <div class="shop_info">\
         <div class="shop_num">'+ contents.contents +'</div>\
         <h3 class="shop_name">'+ contents.shop_name +'</h3>\
         <p class="category">'+ contents.category +'</p>\
         <p class="introduction">'+ contents.introduction +'</p>\
       </div>\
       </a>\
     </div>\
   </li>'
   shoplistHtml = shoplistHtml.replace(/\r?\n/g, '<br>');

   /////////jsonを出力したリストを表示させる
   $(shoplistHtml).appendTo(".shoplist .row").hide().fadeIn();
   dataCount++;
   }
  
   if (dataCount <= 0) {
     $("<li class=\".shoplist .row\">該当する情報がありません。</li>").appendTo(".col sm-12").hide().fadeIn();
   }
}
function eventJson(data) {
  ///一旦リストを初期化
  $(".event_list").empty();
  let dataCount = 0;
  for (let e = 0; e < 6; e++ in data.contents) {
    /////////jsonデータ出力箇所をhtmlテンプレートに登録
    let contents = data.contents[e];
    let eventHtml = '<li class="event_card">\
    <a href="/en/event/' + contents.id + '">\
      <div class="thumbnail_image">\
        <img src="/cms-img/shop/' + contents.thumbnail_image + '" alt="">\
      </div>\
      <div class="thumbnail_info">\
        <div class="thumbnail_ico">\
          <div class="event_date"><span class="start_date">' + contents.start_date + '</span><span class="end_date">' + contents.end_date + '</span></div>\
          <div class="event_category">\
            <span class="category category_0' + contents.category + '"></span>\
          </div>\
        </div>\
        <h3 class="title">' + contents.title + '</h3>\
      </div>\
    </a>\
  </li>'
  /////////jsonを出力したリストを表示させる
  $(eventHtml).appendTo(".event_list").hide().fadeIn();
  dataCount++;
  }
  if (dataCount <= 0) {
    $("<li class=\"event_list\"><p>該当する情報がありません。</p></li>").appendTo(".event_list").hide().fadeIn();
  }
}


/*///////////////////////////////
///初期表示処理
///////////////////////////////*/
$(window).on('load',function() {
    //Ajaxに渡すデータ（初期値）
    //Ajax取得を行う
    $.ajax({
        url: NewsJson,
        dataType:"json"
    })
    .done(function(data) {
      //成功した場合の処理
      newsJson(data);
      //箱の高さをそろえ
      // matchHeught();
    })
    .fail(function(data) {
      //失敗した場合の処理
      $(".news_list").append("<p class=\"news_list__item\">データの取得に失敗しました。</p>");
    });
    $.ajax({
      url: ShopJson,
      dataType:"json"
    })
    .done(function(data) {
      //成功した場合の処理
      shopJson(data);
      //箱の高さをそろえ
      // matchHeught();
    })
    .fail(function(data) {
      //失敗した場合の処理
      $(".shoplist").append("<li class=\"shoplist\"><p>データの取得に失敗しました。</p></li>");
    });
    $.ajax({
      url: EventJson,
      dataType:"json"
    })
    .done(function(data) {
      //成功した場合の処理
      eventJson(data);
      // slider
      $('.slider').slick({
        autoplay:true,
        autoplaySpeed:5000,
        slidesToShow:2,
        centerMode: true,
        centerPadding: '20%',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        dots: false,
        responsive: [{
          breakpoint: 980,settings: { //481px～600pxでは2画像表示
            centerMode: true,
            centerPadding: '10%',
          },
          breakpoint: 768,settings: { //481px～600pxでは1画像表示
            arrows: false,
            slidesToShow:1,
            centerMode: false,
            centerPadding: '0%',
            dots: true,
            dotsClass: 'slick-dots',
          }
        }]
      });

      //箱の高さをそろえ
      // matchHeught();
    })
    .fail(function(data) {
      //失敗した場合の処理
      $(".event_box").append("<p class=\"event_box\">データの取得に失敗しました。</p>");
    });
});

$(function() {
  NewsJson = '/en/' + 'module' + '/' +'json' + '/' +'newsdata.json';
  ShopJson= '/en/' + 'module' + '/' +'json' + '/' +'shopdata.json';
  EventJson= '/en/' + 'module' + '/' +'json' + '/' +'eventdata.json';
});
